import Marquee from "react-fast-marquee";

const WORDS = ["Deep Tissue", "Sports Massage", "Relaxation", "Hot & Cold Stone", "Myofascial Release", "Trigger Point"];

export default function EditorialMarquee() {
  return (
    <div className="border-y border-sand/70 py-10" data-testid="editorial-marquee">
      <Marquee speed={25} gradient={false} pauseOnHover>
        {WORDS.map((w) => (
          <span key={w} className="mx-12 flex items-center gap-24">
            <span className="font-serif text-3xl font-light italic tracking-tight text-forest/80 lg:text-4xl">{w}</span>
            <span className="h-2 w-2 rotate-45 bg-clay" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
